import Vue from 'vue';
import Component from 'vue-class-component';
import { Async } from '@/utils/AsyncDecorators';
import { store } from '@/store';
import { versioneInSituStore } from '@/modules/VersioneInSitu/store/VersioneInSitu.store';
import { areaSaggioStore } from '@/modules/AreaSaggio/store/areaSaggio.store';
import { areaSaggioClasseDiametricaStore } from '@/modules/AreaSaggioClasseDiametrica/store/areaSaggioClasseDiametrica.store';
import { domainStore } from '@/modules/domains';
import { ClasseDiametricaIntersection } from '../../utils/classeDimatrica';
import { Watch } from 'vue-property-decorator';
import row from './row.vue';
import { tabellaRiepilogativa } from '../../utils/tabellaRiepilogativa';
import { printerHelper } from '@/modules/printer';
import { CalculationUtils } from '../../utils/CalculationUtils';
import { parseTabelDataExportFormat } from '../../utils/parseTabelDataExportFormat';
import { reportStore } from '../../store/report.store';

@Component({
  components: {
    row
  }
})
export default class Index extends Vue {

  @Async({ async get() { return await versioneInSituStore.getters.current() }, default: {}, lazy: false })
  currentVersion: server.VersioneInSitu;

  @Async({ async get() { return (await areaSaggioStore.getters.getAll()).sort((a, b) => a.nome.localeCompare(b.nome)); }, default: [], lazy: false })
  areeSaggio: server.areaSaggio[];

  @Async({ async get() { return await areaSaggioClasseDiametricaStore.getters.getAll() }, default: [], lazy: false })
  areeSaggioClasseDiametrica: server.areaSaggioClasseDiametrica[];

  @Async({ async get() { return await await domainStore.getters.specieArboree(); }, default: [], lazy: false })
  specieArboree: domains.domini[];

  @Watch('filter.text')
  change(n, o) { this.showsize = 20; }
  showsize: number = 20;

  get areeSaggioAutocomplete() {
    if (this.areeSaggio.length <= 0) return [];
    return this.areeSaggio.map((m) => {
      return {
        key: m.id,
        value: m.id,
        description: m.nome,
      } as server.autocomplete
    })
  }

  get navigation() {
    if (!this.areaSaggioId) return null
    return this.areeSaggioAutocomplete.find(f => f.key === this.areaSaggioId) || {} as server.autocomplete;
  }
  set navigation(value: server.autocomplete) {
    if (value.key !== this.areaSaggioId) {
      store.actions.navigation.set_filter({ area: "areaSaggio", id: value ? value.key : null });
      reportStore.actions.set_logarithmic_regression(value ? value.key : null);
    }
  }

  get areaSaggioId() {
    return store.getters.navigation.selected("areaSaggio");
  }

  tab = new tabellaRiepilogativa();

  get classiDiametricheExtended(): IClasseDiametrica[] {
    if (!this.areaSaggioId) return [];
    const result = this.areeSaggioClasseDiametrica
      .filter(i => i.areaSaggioId === this.areaSaggioId)
      .map(m => new ClasseDiametricaIntersection(m, this.areeSaggio.find(f => f.id === m.areaSaggioId), this.specieArboree.find(f => f.id === m.specie)))
      .sort((a, b) => {
        const specieOrder = a.specieOrderIndex - b.specieOrderIndex;
        if (specieOrder !== 0)
          return specieOrder;
        return a.diametro - b.diametro;
      });
    if (result.length > 0) {
      this.tab = new tabellaRiepilogativa(result);
      this.tab.tabella.pianteAdEttaro.push({
        specie: "Totale",
        value: this.tab.tabella.pianteAdEttaro.map(m => m.value).reduce((a, b) => a + b)
      });
      this.tab.tabella.areaBasimetricaAdEttaro.push({
        specie: "Totale",
        value: this.tab.tabella.areaBasimetricaAdEttaro.map(m => m.value).reduce((a, b) => a + b)
      });
      this.tab.tabella.diametroMedio.push({
        specie: "Totale",
        value: CalculationUtils.getDiametroMedio(
          this.tab.tabella.areaBasimetricaAdEttaro.find(f => f.specie === "Totale")?.value || 0,
          this.tab.tabella.pianteAdEttaro.find(f => f.specie === "Totale")?.value || 0)
      });
      this.tab.tabella.altezzaMedia.push({
        specie: "Totale",
        value: CalculationUtils.getAltezzaIpsometrica(this.tab.tabella.diametroMedio.find(f => f.specie === "Totale")?.value || 0)
      });
      this.tab.tabella.volumeAdEttaro.push({
        specie: "Totale",
        value: this.tab.tabella.volumeAdEttaro.map(m => m.value).reduce((a, b) => a + b)
      });
    }
    return result;
  }

  get specieArboreeSelezionateIds(): number[] {
    if (this.classiDiametricheExtended.length <= 0) return [];
    return [...new Set(this.classiDiametricheExtended.map(m => m.specie))]
  };

  get specieArboreeInserite(): domains.domini[] {
    if ((this.specieArboree || []).length <= 0 || (this.specieArboreeSelezionateIds || []).length <= 0) return [];
    const result: domains.domini[] = [];
    this.specieArboreeSelezionateIds.forEach(m => {
      const specie = this.specieArboree.find(f => f.id === m)
      if (specie) result.push(specie);
    })
    return result;
  }

  exportExcel() {
    var heading: string[] = [""];
    var arrayToExport: any[][] = [];

    for (var i = 0; i < 5; i++) {
      arrayToExport[i] = [];
    }
    arrayToExport[0][" "] = "Numero piante (N/ha)";
    arrayToExport[1][" "] = "Area basimetrica (m^2/ha)";
    arrayToExport[2][" "] = "Diametro medio (cm)";
    arrayToExport[3][" "] = "Altezza media (m)";
    arrayToExport[4][" "] = "Volume stimato (m^3/ha)";

    parseTabelDataExportFormat(heading, arrayToExport, this.specieArboreeInserite, this.tab.tabella);
    printerHelper.printExcel("tabella-riepilogativa", arrayToExport, "Tabella Riepilogativa");
  }
}